export default {
    
    // Brand and tagline
    "sri_astro_veda": "సూర్య మీడియా",
    "footer_tagline": "జ్యోతిష్యం & వాస్తు. ఆధునిక, వ్యక్తిగత, విశ్వసనీయ.",

    // Navigation
    "navigation": "నావిగేషన్",
    "home": "హోమ్",
    "about": "గురించి",
    "contact": "సంప్రదింపులు", 
    "get_reading": "రీడింగ్ పొందండి",

    // Core Services
    "core_services_footer": "ప్రధాన సేవలు",
    "birth_chart_footer": "జన్మ చార్ట్",
    "match_kundli_footer": "కుండలి మ్యాచింగ్",
    "ascendant_footer": "లగ్నం",
    "dasha_analysis_footer": "దశా విశ్లేషణ",
    "nakshatra_footer": "నక్షత్రం",
    "numerology_footer": "అంకజ్యోతిష్యం",

    // Predictions
    "predictions_footer": "భవిష్యవాణులు",
    "life_predictions_footer": "జీవిత భవిష్యవాణులు",
    "2025_report_footer": "2025 రిపోర్ట్",
    "daily_horoscope_footer": "దైనిక రాశిఫలం",
    "love_report_footer": "ప్రేమ రిపోర్ట్",
    "career_report_footer": "కెరీర్ రిపోర్ట్",
    "health_report_footer": "ఆరోగ్య రిపోర్ట్",

    // Remedies
    "remedies_footer": "పరిహారాలు",
    "lal_kitab_footer": "లాల్ కితాబ్",
    "mangal_dosha_footer": "మంగళ దోషం",
    "kalsarp_dosh_footer": "కాలసర్ప దోషం",
    "sade_sati_footer": "సాడేసతి",
    "ask_question_footer": "ప్రశ్న అడగండి",
    "gemstones_footer": "రత్నాలు",

    // Support
    "support": "సహాయం",
    "whatsapp_support": "WhatsApp సహాయం",
    "available_24_7": "చాట్ సహాయం",

    // Footer bottom
    "all_rights_reserved": "అన్ని హక్కులు రక్షిత",
    "made_with": "తో తయారు చేయబడింది",
    "in_india": "భారతదేశంలో",
    "privacy_policy": "గోప్యతా విధానం",
    "terms_of_service": "సేవా షరతులు",
    "disclaimer": "నిరాకరణ",
    "cancellation_policy": "రద్దు విధానం",
    "shipping_policy": "షిప్పింగ్ విధానం"
}
